window.process ||= window